class DZModelCourtshipBase {

    /**
     * 主键
     */
    id="";

    /**
     * 需求标题
     */
    title="";

    /**
     * 列表图片ID
     */
    listCoverId="";

    /**
     * 详细地址ID
     */
    addressId="";

    /**
     * 补充说明
     */
    describe="";

    /**
     * 土地图片ID，多个逗号隔开
     */
    imageIds="";

    /**
     * 联系人ID
     */
    contactsId="";

    /**
     * 更新用户ID
     */
    updateBy="";

    /**
     * 更新时间
     */
    updateTime="";

    /**
     * 发布用户ID
     */
    createBy="";

    /**
     * 创建时间
     */
    createTime="";
}
export default DZModelCourtshipBase